import { ProductTypes } from 'common/src/modules/products/product-types';
import { PositionGroupModel } from '../models';
import { PositionMediaTypeEnum } from '../enums';

export function getPositionsStartCount(positions: {[key in ProductTypes]?: any[]}, productType: ProductTypes): number {
  const order: ProductTypes[] = [
    ProductTypes.GOODS,
    ProductTypes.SERVICES,
    ProductTypes.DIGITAL,
    ProductTypes.BUNDLE,
    ProductTypes.ARBITRARY,
    ProductTypes.CORRECTION,
    ProductTypes.OVERDUE_FEE,
    ProductTypes.PREPAYMENT,
    ProductTypes.INVOICE,
  ];

  let count = 0;

  for (let i = 0; i < order.length; i++) {
    if (order[i] === productType) { break; }
    if (positions[order[i]] && positions[order[i]].length) {
      count = count + positions[order[i]].length;
    }
  }

  return count;
}

export function getGroupedPositionsStartCount(allGroups: PositionGroupModel[], group: PositionGroupModel): number {
  const groupIndex = allGroups.findIndex((g: PositionGroupModel) => g.groupId === group.groupId);

  if (groupIndex === 0) { return 0; }

  let count = 0;

  for (let i = 0; i < groupIndex; i++) {
    if (allGroups[i] && allGroups[i].positions.length) {
      count = count + allGroups[i].positions.length;
    }
  }

  return count;
}

export function groupWithEveryMediaPosition(group: PositionGroupModel): boolean {
  return group.positions.every(p => p.mediaType === PositionMediaTypeEnum.IMAGE || p.mediaType === PositionMediaTypeEnum.TEXT);
}
